import { CxsBasket } from '../model';
import { markProductUpdate, updateEntry } from '../utils';

export const removeFromBasket = (basket: CxsBasket, productId: string): CxsBasket => {
    const existingLineIndex = basket.lines.findIndex(line => line.variantNo === productId);
    if (existingLineIndex === -1) {
        return basket;
    }
    const existingLine = basket.lines[existingLineIndex];
    let lines = [...basket.lines.slice(0, existingLineIndex), ...basket.lines.slice(existingLineIndex + 1)];
    existingLine.relatedFreeProducts?.forEach(freeProductId => {
        const freeProductLineIndex = lines.findIndex(({ variantNo }) => variantNo === freeProductId);
        if (freeProductLineIndex > -1) {
            const newQuantity = lines[freeProductLineIndex].quantity - existingLine.quantity;
            const newQuantityThatIsFree = lines[freeProductLineIndex].quantityThatIsFree - existingLine.quantity;
            if (newQuantity === 0) {
                lines = removeFromBasket({ ...basket, lines }, freeProductId).lines;
            } else {
                lines = updateEntry(
                    lines,
                    { quantity: newQuantity, quantityThatIsFree: newQuantityThatIsFree },
                    freeProductLineIndex
                );
            }
        }
    });
    return {
        ...basket,
        lines,
        ...markProductUpdate(basket, productId)
    };
};
